import React from 'react';
import { connect } from 'react-redux';
import { fromReservation } from 'store/selectors';
import { putGuestInCabin, removeGuestFromCabin } from 'store/actions';

import { SelectGuestListEntry } from 'components';

const SelectGuestListEntryContainer = props => (
  <SelectGuestListEntry {...props} />
);

const mapStateToProps = (state, { id, departureId }) => {
  const guest = fromReservation.getGuest(state, id);
  const activeCabinId = fromReservation.getActiveCabin(state, departureId);
  const selected = guest.selectedCabin && guest.selectedCabin[departureId] === activeCabinId;
  return {
    guest,
    activeCabin: activeCabinId,
    selected: !!selected,
    canBeAdded: fromReservation.canGuestBeAddedToActiveCabin(state, id),
    remainingBeds: fromReservation.getRemainingBeds(state, activeCabinId),
  };
};

const mapDispatchToProps = (dispatch, { id }) => ({
  addToCabin: cabin => dispatch(putGuestInCabin(id, cabin)),
  removeFromCabin: cabin => dispatch(removeGuestFromCabin(id, cabin)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectGuestListEntryContainer);



// WEBPACK FOOTER //
// ./src/containers/SelectGuestListEntry.js